import { useMemo } from 'react';
import { useAuth } from 'features/auth';

/**
 * @description An hook to retrieve (and, until we remove Immmutable) unwrap the Immutable authUser
 * @returns {object | null} The currently logged-in user
 */
export const useAuthUser = () => {
  const { user: immutableUser } = useAuth();
  const user = useMemo(() => immutableUser?.toJS() ?? null, [immutableUser]);

  return user;
};
